import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeleteCategoriesToFotoboxesMutation,
  useSendCategoriesToFotoboxesMutation,
} from '../../../../core/api/CategoryApi'

export const useUpdateCategoryStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}
  const [sendCategoriesToFotoboxes] = useSendCategoriesToFotoboxesMutation()
  const [deleteCategoriesToFotoboxes] = useDeleteCategoriesToFotoboxesMutation()

  const onUpdateStation = (categoriesGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deleteCategoriesToFotoboxes({
        categoriesGuids: [categoriesGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendCategoriesToFotoboxes({
        categoriesGuids: [categoriesGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
